import * as React from 'react';
import {useCallback, useState} from 'react';
import LandingPageConfig from "../../landing/objects/LandingPageConfig";
import CheckboxInput from "../../shared/forms/inputs/CheckboxInput";
import {FormattedMessage} from "react-intl";
import {FIELD_TNC} from "../../landing/components/SubscriptionForm";
import TermLink from "./TermLink";

export interface IDefaultTermTemplateProps {
    landingPageConfig: LandingPageConfig;
}

export default (props: IDefaultTermTemplateProps) => {
    const { landingPageConfig } = props;
    const [ expanded, setExpanded ] = useState(false);
    const toggleReadMore = useCallback(() => {
        setExpanded(!expanded);
    }, [expanded]);
    return (
        <>
            <CheckboxInput inputID={FIELD_TNC}
                           label={(
                               <>
                                   <p>
                                       <FormattedMessage id="landing.subscription.field.terms_and_conditions.1"
                                                         values={{
                                                             merchantName: landingPageConfig.merchantName
                                                         }}
                                       />
                                       &nbsp;
                                       <a href="###" onClick={toggleReadMore}>
                                           {!expanded ? (
                                               <FormattedMessage id="landing.subscription.field.terms_and_conditions.read_more" />
                                           ) : (
                                               <FormattedMessage id="landing.subscription.field.terms_and_conditions.read_less" />
                                           )}
                                       </a>
                                   </p>
                                   {expanded && (
                                       <>
                                           <p>
                                               <FormattedMessage id="landing.subscription.field.terms_and_conditions.2"
                                                                 values={{
                                                                     merchantName: landingPageConfig.merchantName,
                                                                     merchantWebSite: landingPageConfig.merchantWebSite,
                                                                     merchantFullAddress: landingPageConfig.merchantFullAddress,
                                                                     supportEmail: landingPageConfig.supportEmail,
                                                                     mobileVirtualNumber: landingPageConfig.mobileVirtualNumber,
                                                                     tncTerm: <TermLink termClass={landingPageConfig.tncTermClass} url={landingPageConfig.tncTermUrl} text={landingPageConfig.tncTermText}><FormattedMessage id="landing.subscription.field.terms_and_conditions.tnc" /></TermLink>,
                                                                     prvTerm: <TermLink termClass={landingPageConfig.prvTermClass} url={landingPageConfig.prvTermUrl} text={landingPageConfig.prvTermText}><FormattedMessage id="landing.subscription.field.terms_and_conditions.prv" /></TermLink>,
                                                                 }}
                                               />
                                           </p>
                                           <p>
                                               <FormattedMessage id="landing.subscription.field.terms_and_conditions.3"
                                                                 values={{
                                                                     otcTerm: <TermLink termClass={landingPageConfig.otcTermClass} url={landingPageConfig.otcTermUrl} text={landingPageConfig.otcTermText}><FormattedMessage id="landing.subscription.field.terms_and_conditions.otc" /></TermLink>,
                                                                 }}
                                               />
                                           </p>
                                       </>
                                   )}
                               </>
                           )}
            />
        </>
    );
}